"use client";

import React, { useState, useEffect } from 'react';
import NewsListItem from './ui/NewsListItem';
import { fetchSimilarNews } from '@/app/utilities/apis';

interface SimilarNewsListProps {
  slug: string;
  maxItems?: number;
}

const SimilarNewsList: React.FC<SimilarNewsListProps> = ({ slug, maxItems = 4 }) => {
  const [news, setNews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSimilarNews = async () => {
      try {
        const { news: fetchedNews } = await fetchSimilarNews(slug, maxItems);
        setNews(fetchedNews || []);
      } catch (error) {
        console.error('Error loading similar news:', error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      loadSimilarNews();
    }
  }, [slug, maxItems]);

  if (loading) {
    return (
      <div className="space-y-3">
        {[...Array(maxItems)].map((_, index) => (
          <div key={index} className="flex gap-3 py-3 animate-pulse">
            <div className="w-29 h-16 bg-gray-200 rounded"></div>
            <div className="flex-1">
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (news.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No similar news available
      </div>
    );
  }

  return (
    <div className="space-y-0">
      {news.map((item, index) => (
        <NewsListItem
          key={item._id}
          news={item}
          isLast={index === news.length - 1}
        />
      ))}
    </div>
  );
};

export default SimilarNewsList;
